/* ============================================================================
   Droplet landing page — runtime
   ----------------------------------------------------------------------------
   The original single-file build ran nine self-invoking blocks at parse time.
   Inside a Shopify section that is not enough: the theme editor re-renders the
   section's HTML on every setting change, which throws away the DOM the old
   listeners were pointing at (and injected <script> tags never re-execute).

   So each original block now lives untouched inside M[] and is handed a small
   context object. Every window/document listener, rAF, timer, observer and
   media-query listener it creates is recorded, which makes a clean teardown
   possible. Boot + teardown are driven from document-level Shopify events that
   are registered once, when this file first loads.
   ========================================================================== */
(function () {
  if (window.__dropletLP) return;

  var M = [];

  function makeCtx() {
    var listeners = [];
    var rafs = [];
    var timeouts = [];
    var intervals = [];
    var observers = [];
    var mqls = [];

    function drop(arr, v) {
      var i = arr.indexOf(v);
      if (i > -1) arr.splice(i, 1);
    }

    var ctx = {
      on: function (t, type, fn, opts) {
        if (!t) return;
        t.addEventListener(type, fn, opts);
        listeners.push([t, type, fn, opts]);
      },
      off: function (t, type, fn, opts) {
        if (!t) return;
        t.removeEventListener(type, fn, opts);
        for (var i = listeners.length - 1; i >= 0; i--) {
          if (listeners[i][0] === t && listeners[i][1] === type && listeners[i][2] === fn) {
            listeners.splice(i, 1);
          }
        }
      },
      raf: function (fn) {
        var id = window.requestAnimationFrame(function (ts) {
          drop(rafs, id);
          fn(ts);
        });
        rafs.push(id);
        return id;
      },
      craf: function (id) {
        window.cancelAnimationFrame(id);
        drop(rafs, id);
      },
      sto: function (fn, ms) {
        var extra = Array.prototype.slice.call(arguments, 2);
        var id = window.setTimeout(function () {
          drop(timeouts, id);
          fn.apply(null, extra);
        }, ms);
        timeouts.push(id);
        return id;
      },
      cto: function (id) {
        window.clearTimeout(id);
        drop(timeouts, id);
      },
      sti: function (fn, ms) {
        var id = window.setInterval(fn, ms);
        intervals.push(id);
        return id;
      },
      cti: function (id) {
        window.clearInterval(id);
        drop(intervals, id);
      },
      io: function (cb, opts) {
        var o = new IntersectionObserver(cb, opts);
        observers.push(o);
        return o;
      },
      ro: function (cb) {
        var o = new ResizeObserver(cb);
        observers.push(o);
        return o;
      },
      mo: function (cb) {
        var o = new MutationObserver(cb);
        observers.push(o);
        return o;
      },
      mm: function (query) {
        var m = window.matchMedia(query);
        return {
          media: m.media,
          get matches() {
            return m.matches;
          },
          addEventListener: function (type, fn) {
            m.addEventListener(type, fn);
            mqls.push([m, type, fn]);
          },
          removeEventListener: function (type, fn) {
            m.removeEventListener(type, fn);
          },
          addListener: function (fn) {
            m.addListener(fn);
            mqls.push([m, 'change', fn]);
          },
          removeListener: function (fn) {
            m.removeListener(fn);
          },
        };
      },
      destroy: function () {
        listeners.forEach(function (l) {
          try {
            l[0].removeEventListener(l[1], l[2], l[3]);
          } catch (e) {}
        });
        rafs.forEach(function (id) {
          window.cancelAnimationFrame(id);
        });
        timeouts.forEach(function (id) {
          window.clearTimeout(id);
        });
        intervals.forEach(function (id) {
          window.clearInterval(id);
        });
        observers.forEach(function (o) {
          try {
            o.disconnect();
          } catch (e) {}
        });
        mqls.forEach(function (m) {
          try {
            if (m[0].removeEventListener) m[0].removeEventListener(m[1], m[2]);
            else m[0].removeListener(m[2]);
          } catch (e) {}
        });
        listeners.length = rafs.length = timeouts.length = 0;
        intervals.length = observers.length = mqls.length = 0;
      },
    };

    return ctx;
  }

/* ---------- module 0 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const nav     = document.getElementById('nav');
  const hero    = document.getElementById('hero');
  const video   = document.getElementById('heroVideo');
  const glow    = document.getElementById('heroGlow');
  const overlay = document.getElementById('heroOverlay');
  const botfade = document.getElementById('heroBotfade');
  const videowrap    = document.getElementById('heroVideowrap');
  const vidfadeTop   = document.getElementById('heroVidfadeTop');
  const vidfadeBottom= document.getElementById('heroVidfadeBottom');
  const mqMobile = __mm('(max-width: 768px)');

  /* pin the video just under the nav: measure the nav's real height live */
  const navEl = document.querySelector('.droplet-lp .nav') || document.querySelector('.shopify-section-group-header-group .header-wrapper') || document.querySelector('.header-wrapper');
  const setNavH = () => document.documentElement.style.setProperty('--nav-h', (navEl ? navEl.offsetHeight : 68) + 'px');
  setNavH();
  __on(window, 'resize', setNavH, { passive:true });
  __on(window, 'load', setNavH);

  /* Templates that reuse this file only for the site nav (the contact page)
     have no scroll hero. --nav-h is wired above, so stop here rather than
     dereferencing hero nodes that were never rendered. */
  if (!document.getElementById('heroFinale')) return;

  /* MOBILE panel slide (clean rebuild). Returns --vid-down: 1 = LOW (Seq1, video fills the
     lower half, bottom at the screen edge), 0 = UP (Seq2, video just under the nav, bottom
     ~mid-viewport). The panel holds LOW through the first text, glides up as the first text
     fades, and rests UP for the second + third text. All px math lives in the CSS calc. */
  function mobilePanelDown(p){
    const t = clamp((p - 0.07) / (0.19 - 0.07), 0, 1);   // begins during the latter part of the 1st-text fade; spread wide so it never rushes to catch up
    const e = t * t * (3 - 2 * t);                       // smoothstep — gentle in/out, no overshoot, settles before the 2nd text
    return 1 - e;                                        // 1 (low) → 0 (up); same start & end position as before
  }
  /* A/B Option B: the buy box follows this section instead of the dark
     testimonials, so the exit fades to the buy box's light background (CSS
     recolours the overlay), the desktop close fades out with it, and the nav
     turns dark only once the dark testimonials have reached it, so it always
     matches what is behind it. */
  const lpRoot = document.querySelector('[data-droplet-lp]');
  const lpB    = !!(lpRoot && lpRoot.getAttribute('data-layout') === 'b');
  const ugcEl  = document.getElementById('ugc');
  function ugcUnderNav(){
    if (!ugcEl) return false;
    return ugcEl.getBoundingClientRect().top <= ((nav && nav.offsetHeight) || 68);
  }
  const intro   = document.getElementById('heroIntro');
  const finale  = document.getElementById('heroFinale');
  const finaleH2 = finale.querySelector('h2');
  const hint    = document.getElementById('heroHint');
  const dotsWrap= document.getElementById('heroDots');
  const callouts= [...document.querySelectorAll('.hero__callout')];
  const dots    = [...document.querySelectorAll('#heroDots .hero__dot')];

  const reduce = __mm('(prefers-reduced-motion: reduce)').matches;
  const LERP   = reduce ? 1 : 0.08;          // handover: 0.08 lerp

  let targetProgress = 0, currentProgress = 0;

  /* ---------- hardened video scrubbing ----------
     Defends against: metadata-not-ready, cached-load races, seek storms,
     a dropped 'seeked' event (freeze), seeking past un-downloaded data,
     and iOS/Safari paused-frame decode. No per-frame cost beyond a few compares. */
  let duration = 0, vReady = false, fullyBuffered = false;
  let lastSeek = -1, seekBusy = false, seekStart = 0, pendingT = null;

  function vInit(){
    if (!vReady && video.duration && isFinite(video.duration) && video.duration > 0){
      duration = video.duration; vReady = true;
    }
  }
  ['loadedmetadata','durationchange','canplay'].forEach(e => video.addEventListener(e, vInit));
  if (video.readyState >= 1) vInit();                       // already loaded (cache)

  video.addEventListener('canplaythrough', () => { fullyBuffered = true; });

  /* wake the decode pipeline so a paused video paints seeked frames (iOS/Safari) */
  function primeDecoder(){
    const r = video.play && video.play();
    if (r && r.then) r.then(() => video.pause()).catch(() => {});
  }
  video.addEventListener('loadeddata', primeDecoder, { once:true });
  ['pointerdown','touchstart','wheel','keydown'].forEach(e =>
    __on(window, e, primeDecoder, { once:true, passive:true }));

  function bufferedEnd(){
    try { return video.buffered.length ? video.buffered.end(video.buffered.length-1) : 0; }
    catch(e){ return duration; }
  }

  /* coalesced seek: only ever one seek in flight; latest target wins */
  function seekTo(t){
    if (!vReady) return;
    t = Math.max(0, Math.min(t, duration - 0.05));
    if (!fullyBuffered){                                    // never seek past downloaded data
      const safe = bufferedEnd() - 0.1;
      if (safe > 0 && t > safe) t = safe;
    }
    if (seekBusy){ pendingT = t; return; }                  // queue, don't pile up
    if (Math.abs(t - lastSeek) < 0.012) return;             // negligible move
    lastSeek = t; seekBusy = true; seekStart = performance.now();
    if (video.fastSeek){ try { video.fastSeek(t); } catch(e){ video.currentTime = t; } }
    else video.currentTime = t;
  }
  video.addEventListener('seeked', () => {
    seekBusy = false;
    if (pendingT != null){ const t = pendingT; pendingT = null; seekTo(t); }
  });

  /* tab switch / bfcache restore: while hidden, rAF is paused and the video
     decoder is often suspended, leaving it stuck on the last frame. On return,
     wake the pipeline and force a REAL re-seek: seeking to the identical
     currentTime is silently dropped by Safari (no 'seeked', no repaint), so we
     nudge one frame off-target here — the rAF loop then lands the exact frame.
     Safari also refuses to wake a decoder for an OFFSCREEN video, so if the
     section isn't near the viewport on return, defer the wake until it is
     (checked each frame by the rAF loop while pending). */
  let needsWake = false;
  function heroNearView(){
    const r = hero.getBoundingClientRect();
    return r.bottom > -window.innerHeight && r.top < 2 * window.innerHeight;
  }
  function doWake(){
    seekBusy = false; pendingT = null; lastSeek = -1;   // unblock + defeat the "negligible move" skip
    fullyBuffered = false;                // re-verify buffered ranges (data may have been evicted while hidden)
    primeDecoder();                       // wake the suspended decoder
    computeTarget();                      // refresh target after paused frames
    if (vReady && duration){              // forced off-target nudge → guaranteed 'seeked' + repaint
      const sp = mqMobile.matches ? Math.min(Math.max(targetProgress / VID_END, 0), 1) : targetProgress;
      const t  = Math.max(0, Math.min(sp * duration, duration - 0.05));
      try { video.currentTime = t > 0.05 ? t - 0.04 : t + 0.04; } catch(e){}
    }
  }
  function onVisible(){
    if (document.hidden) return;
    if (heroNearView()) doWake(); else needsWake = true;
  }
  __on(document, 'visibilitychange', onVisible);
  __on(window, 'pageshow', onVisible);

  function computeTarget(){
    const rect  = hero.getBoundingClientRect();
    const range = hero.offsetHeight - window.innerHeight;
    targetProgress = range > 0 ? Math.min(Math.max(-rect.top / range, 0), 1) : 0;
  }
  __on(window, 'scroll', computeTarget, { passive:true });
  __on(window, 'resize', computeTarget);

  const clamp = (v,a,b) => Math.min(Math.max(v,a),b);
  const band  = (p,a,b,c,d) => (p<=a||p>=d) ? 0 : p<b ? (p-a)/(b-a) : p>c ? 1-(p-c)/(d-c) : 1;
  const ease  = t => 1 - Math.pow(1-t, 3);   // easeOutCubic

  /* callout windows, mapped to the four video beats (progress space).
     Re-anchored for the replacement hydrific-hero-5.mp4 (15.1s): clamp approach ~2.8s,
     snap ~5.5s, glow/sensing 8.0–10.8s, camera pull-back 10.8–14.0s, final settle ~14.2s. */
  const WIN = [
    [0.17, 0.24, 0.37, 0.42],   // clamps on — enters with the approach, holds through the ~5.5s snap, fully out before the cable extends (~6.5s)
    [0.475, 0.53, 0.675, 0.74], // ultrasonic cutaway (desktop) — enters as the clamps text clears, fully in by the 8.0–10.8s glow
  ];
  /* MOBILE: ultrasound moment held very slightly shorter & exits a touch sooner, so the final
     text can enter earlier and linger longer before the exit (desktop WIN[1] is untouched).
     Mobile compresses the video into p∈[0,VID_END], so its glow sits earlier in progress space. */
  const WIN_ULTRA_M = [0.46, 0.52, 0.61, 0.68];
  /* Option B: the section opens straight on the device (no intro beat), so the first
     callout comes in almost as soon as the section pins; same exit as WIN[0].
     Raise the first two numbers to bring it in later. */
  const WIN_CLAMP_B = [0.05, 0.11, 0.37, 0.42];
  const beatStarts  = [0, 0.17, 0.50, 0.82];
  const beatCenters = [0.06, 0.31, 0.60, 0.93];
  /* MOBILE exit timeline split: video animation completes by VID_END; the section then holds
     the finished composition briefly and fades to black only in the tail (a separate exit). */
  const VID_END = 0.88;

  function mainLoop(){
    __raf(mainLoop);          // schedule first → a throw below can't kill the loop
    if (needsWake && heroNearView()){ needsWake = false; doWake(); }   // deferred tab-return wake
    currentProgress += (targetProgress - currentProgress) * LERP;
    const p = currentProgress;
    const isMobile = mqMobile.matches;

    /* scrub (coalesced; watchdog clears a dropped 'seeked' so it can't freeze).
       MOBILE: the video animation finishes by VID_END and then holds its last frame — the
       section tail is reserved for the exit-to-black. DESKTOP plays across the whole timeline. */
    if (vReady){
      if (seekBusy && performance.now() - seekStart > 250) seekBusy = false;
      const sp = isMobile ? clamp(p / VID_END, 0, 1) : p;
      seekTo(sp * duration);
    }

    /* video placement — MOBILE slides the whole panel as one element and crossfades the
       white gradient from its top edge (Seq1) to its bottom edge (Seq2). DESKTOP keeps the
       full-frame entrance (translate + gentle zoom). */
    if (isMobile){
      /* Option B has no intro above the product, so the panel starts UP (Seq2) right
         under the nav instead of low with an empty white band above it */
      const down = lpB ? 0 : mobilePanelDown(p);             // 1 = low (Seq1), 0 = up (Seq2)
      videowrap.style.setProperty('--vid-down', down.toFixed(4));
      video.style.transform = 'none';
      /* top gradient exits EARLY in the rise (fully gone by ~60% of the way up) so it never
         covers the clamp reaching the top of the frame; bottom fade timing unchanged */
      /* Option B: the panel is already up, so the top feather is what blends it into the
         header copy above. Full while the section scrolls in, then it clears quickly once
         the section pins so it never covers the clamp. Keyed to the raw scroll position
         (targetProgress), not the eased p, so scrolling back up restores the feather the
         moment the section unpins instead of trailing behind it with a hard edge. */
      vidfadeTop.style.opacity    = (lpB ? 1 - clamp(targetProgress / 0.06, 0, 1)
                                         : clamp((down - 0.4) / 0.6, 0, 1)).toFixed(3);
      vidfadeBottom.style.opacity = (1 - down).toFixed(3);    // white on BOTTOM edge — stays for the final composition
    } else {
      /* Option B: no intro to clear, so the product is already in place — the page
         scroll itself brings it in, with no empty band above it */
      const rise = lpB ? 1 : ease(clamp(p / 0.2, 0, 1));
      const vy = 30 * (1 - rise);                            // 30vh below → resting
      const vs = 0.85 + 0.15 * rise;                         // gentle zoom in
      video.style.transform = `translateY(${vy.toFixed(2)}vh) scale(${vs.toFixed(4)})`;
    }

    /* intro above the product — pushed up & faded as it rises.
       DESKTOP exits quicker (by p .09) so the heading clears before the rising product
       reaches it; MOBILE keeps .13 (its panel choreography is keyed to that window). */
    if (intro){                                  // Option B renders no intro (moved below the buy box)
      const it = clamp(p / (isMobile ? 0.13 : 0.09), 0, 1);
      intro.style.transform = `translateY(${-it*20}vh)`;
      intro.style.opacity   = (1 - it).toFixed(3);
    }
    hint.style.opacity    = (1 - clamp(p/0.05,0,1)).toFixed(3);
    botfade.style.opacity = (1 - ease(clamp(p/0.2,0,1))).toFixed(3);

    /* aqua glow peaks across the tech cutaway (replacement video: glow 8.0–10.8s → p .53–.72) */
    glow.style.opacity = band(p, 0.49, 0.56, 0.70, 0.78).toFixed(3);

    /* side callouts — slide + fade reveal (opacity/transform only) */
    callouts.forEach((el,i) => {
      const win = (lpB && i === 0) ? WIN_CLAMP_B
                : (isMobile && i === 1) ? WIN_ULTRA_M : WIN[i];   // mobile ultrasound exits a touch sooner
      const v  = band(p, ...win);
      const dx = isMobile ? 0 : (el.classList.contains('hero__callout--left') ? -1 : 1) * (1-v) * 1.8;
      el.style.opacity   = v.toFixed(3);
      el.style.transform = `translate(${dx * 16}px, ${(1 - v) * 1.6 * 16}px)`;
    });

    /* final text + fade-to-black.
       MOBILE: the final text uses the same lower-area layout + slide/fade entrance as callouts
       2-3 and stays fully readable while the video finishes. The black fade is a SEPARATE exit
       phase that starts only AFTER the video animation is complete (brief hold, then dim → next
       section). DESKTOP keeps the centered light-over-dark close, tied to its own timeline. */
    /* fade-to-black is a scroll-PAST EXIT transition on BOTH desktop and mobile: the section
       stays fully bright through the entire pinned phase, then dims as it releases toward the
       next (dark) section — dimming and scrolling-out happen together, with the black bg ready
       for the next section. exitProgress: 0 while pinned, 0→1 as the section scrolls out. */
    const range   = hero.offsetHeight - window.innerHeight;
    const rectTop = hero.getBoundingClientRect().top;
    const exitProgress = range > 0 ? clamp((-rectTop - range) / window.innerHeight, 0, 1) : 0;
    const dark = ease(clamp(exitProgress / 0.55, 0, 1));

    if (isMobile){
      const ffv = clamp((p - 0.76) / 0.07, 0, 1);     // mobile final text: read bright in the lower area, holds through the exit
      finale.style.opacity   = ffv.toFixed(3);
      finale.style.transform = `translateY(${((1 - ffv) * 1.6 * 16).toFixed(2)}px)`;
      /* finale h2 ink -> white in exact lockstep with the dark exit overlay (mobile only).
         Option B exits to light, so the stylesheet's ink stays. */
      finaleH2.style.color = lpB ? '' : `rgb(${Math.round(12 + 243*dark)}, ${Math.round(17 + 238*dark)}, ${Math.round(22 + 233*dark)})`;
    } else {
      finaleH2.style.color = '';   /* desktop keeps its stylesheet white — never inline-overridden */
      /* desktop close reveals at its ORIGINAL timing (during the pinned scroll), independent of
         the blackout; the blackout remains the separate scroll-past exit.
         Option B: the white close would vanish into the light exit, so it fades out with it. */
      const fv = band(p, 0.82, 0.90, 1.0, 1.06) * (lpB ? 1 - dark : 1);
      finale.style.opacity   = fv.toFixed(3);
      finale.style.transform = `translate(-50%,calc(-50% + ${((1-fv)*1.6*16).toFixed(2)}px)) scale(${(0.96 + 0.04*fv).toFixed(3)})`;
    }
    overlay.style.opacity  = dark.toFixed(3);   /* reaches 1.0 — fully the next section's colour */
    if (nav) nav.classList.toggle('is-dark', lpB ? ugcUnderNav() : dark > 0.45);
    dotsWrap.classList.toggle('on-dark', !lpB && dark > 0.45);

    /* dots */
    let beat = 0;
    for (let i = beatStarts.length-1; i>=0; i--){ if (p >= beatStarts[i]){ beat=i; break; } }
    dots.forEach((d,i) => d.classList.toggle('is-active', i===beat));
  }

  /* Option B, phones: the closing text sits in the upper half of the pinned
     frame and everything under it is empty, so the buy box used to arrive a
     near-blank screen later. Pull it up over that empty band so it starts just
     below the closing text. Measured, not hard-coded, because the text block's
     height depends on the copy and the screen width. The pull is always less
     than the scroll left after the video finishes (VID_END), so the box only
     rises into the band once it is empty. Re-applied only when the value
     really changes, so a toolbar resize can't make it jump. */
  if (lpB){
    const bbEl = document.getElementById('buybox');
    const stickyEl = hero.querySelector('.hero__sticky');
    let bbPull = -1;
    const fitBuybox = () => {
      if (!bbEl || !stickyEl) return;
      let pull = 0;
      if (mqMobile.matches){
        const free = stickyEl.clientHeight - (finale.offsetTop + finale.offsetHeight) - 12;
        pull = free > 0 ? Math.round(free) : 0;
      }
      if (Math.abs(pull - bbPull) < 3) return;
      bbPull = pull;
      bbEl.style.marginTop = pull ? (-pull) + 'px' : '';
    };
    fitBuybox();
    __on(window, 'resize', fitBuybox, { passive:true });
    __on(window, 'load', fitBuybox);
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', fitBuybox);
    else if (mqMobile.addListener) mqMobile.addListener(fitBuybox);
  }

  dots.forEach((d,i) => d.addEventListener('click', () => {
    const range = hero.offsetHeight - window.innerHeight;
    const top   = hero.getBoundingClientRect().top + window.scrollY + beatCenters[i]*range;
    window.scrollTo({ top, behavior:'smooth' });
  }));

  computeTarget();
  __raf(mainLoop);
});

/* ---------- module: Option B brand band ----------
   The "Backed by the makers of" lockup, moved below the buy box. Reveals once as
   it scrolls in (.is-in), then lifts and fades as it leaves under the nav — the
   same exit the lockup had inside the scroll section. Opacity/transform only. */
M.push(function(__c){
  var __on=__c.on,__io=__c.io,__raf=__c.raf,__mm=__c.mm;

  const band  = document.getElementById('brandband');
  const inner = document.getElementById('brandbandInner');
  if (!band || !inner) return;

  const reduce = __mm('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)){ band.classList.add('is-in'); return; }

  __io(([e], obs) => {
    if (e.isIntersecting){ band.classList.add('is-in'); obs.disconnect(); }
  }, { threshold:0.2 }).observe(band);

  const nav = document.getElementById('nav');
  let raf = 0;
  function sync(){
    raf = 0;
    const navH = (nav && nav.offsetHeight) || 68;
    const r = inner.getBoundingClientRect();
    const out = Math.min(Math.max((navH + 40 - r.top) / (r.height * 0.9), 0), 1);
    inner.style.opacity   = (1 - out).toFixed(3);
    inner.style.transform = `translateY(${(-out * 8).toFixed(2)}vh)`;
  }
  const queue = () => { if (!raf) raf = __raf(sync); };
  sync();
  __on(window, 'scroll', queue, { passive:true });
  __on(window, 'resize', queue, { passive:true });
});

/* ---------- module 1 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const root = document.getElementById('topHero');
  if (!root) return;
  const vd = root.querySelector('.vhero__video--d');
  const vm = root.querySelector('.vhero__video--m');
  const mqMobile = __mm('(max-width: 768px)');
  const reduce   = __mm('(prefers-reduced-motion: reduce)').matches;

  function hydrate(v){
    if (!v || v.dataset.loaded) return;
    const src = v.getAttribute('data-src');
    if (src){ v.src = src; v.dataset.loaded = '1'; v.load(); }
  }
  function playSafe(v){
    if (reduce || !v) return;                 // reduced motion → keep the static poster
    const go = () => { const p = v.play(); if (p && p.catch) p.catch(()=>{}); };
    if (v.readyState >= 2) go();
    else v.addEventListener('loadeddata', go, { once:true });
  }
  function activate(){
    const on  = mqMobile.matches ? vm : vd;
    const off = mqMobile.matches ? vd : vm;
    if (off){ try { off.pause(); } catch(e){} }
    hydrate(on);
    playSafe(on);
  }
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', activate);
  else if (mqMobile.addListener) mqMobile.addListener(activate);
  activate();

  /* transparent header while the hero video sits behind the nav (both breakpoints);
     reverts to the normal frosted nav once scrolled past the hero */
  const navEl = document.getElementById('nav');
  /* Option B's text-only header is white, so the nav keeps its normal frosted
     light look there instead of going transparent over a video */
  const textOnly = root.classList.contains('vhero--text');
  function syncNavTransparent(){
    if (!navEl) return;
    if (textOnly){ navEl.classList.remove('is-transparent'); return; }
    const navH = navEl.offsetHeight || 68;
    navEl.classList.toggle('is-transparent', window.scrollY < (root.offsetHeight - navH));
  }
  syncNavTransparent();
  __on(window, 'scroll', syncNavTransparent, { passive:true });
  __on(window, 'resize', syncNavTransparent, { passive:true });

  /* reveal as soon as the DOM is ready — NOT on window 'load', which would wait
     for the scroll section's large scrub video to finish downloading. Double-rAF
     lets the initial hidden state paint first so the transition actually animates. */
  const reveal = () => __raf(() => __raf(() => root.classList.add('is-in')));
  if (document.readyState === 'loading') __on(window, 'DOMContentLoaded', reveal, { once:true });
  else reveal();

  /* tab return + bfcache restore: browsers can leave the muted autoplay video paused, and
     Safari doesn't reliably fire visibilitychange on a bfcache restore — listen to both.
     Also re-sync the transparent-nav state against the restored scroll position. */
  function wakeHero(){
    if (document.hidden) return;
    const on = mqMobile.matches ? vm : vd;
    if (on && on.paused) playSafe(on);
    syncNavTransparent();
  }
  __on(window, 'visibilitychange', wakeHero, { passive:true });
  __on(window, 'pageshow', wakeHero, { passive:true });
});

/* ---------- module 2 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const section = document.getElementById('buybox');
  if (!section) return;
  const reduce = __mm('(prefers-reduced-motion: reduce)').matches;

  /* ---- gallery ---- */
  const stage  = document.getElementById('bbStage');
  const slides = [...stage.querySelectorAll('.bb__slide')];
  const thumbs = [...document.querySelectorAll('#bbThumbs .bb__thumb')];
  const dots   = [...document.querySelectorAll('#bbDots .bb__dot')];
  let idx = 0;
  const n = slides.length;
  function show(i){
    idx = (i + n) % n;
    slides.forEach((s,k)=> s.classList.toggle('is-active', k===idx));
    thumbs.forEach((t,k)=>{ t.classList.toggle('is-active', k===idx); t.setAttribute('aria-selected', k===idx?'true':'false'); });
    dots.forEach((d,k)=> d.classList.toggle('is-active', k===idx));
    syncSpin();
  }
  /* slide 1 360 film: endless silent loop over its first-frame poster. Loaded
     after the page has settled, plays only while slide 1 is showing and the
     gallery is on screen; reduced motion keeps the still frame. */
  const spin = stage.querySelector('.bb__slide-video');
  let spinSeen = false, spinLoaded = false;
  function spinLoad(){
    if (!spin || spinLoaded || reduce) return;
    spinLoaded = true;
    spin.muted = true; spin.loop = true; spin.playsInline = true;
    const ready = ()=> spin.classList.add('is-ready');
    spin.addEventListener('playing', ready);
    spin.addEventListener('ended', ()=>{ try{ spin.currentTime = 0; spin.play(); }catch(e){} }); // belt and braces for loop
    spin.preload = 'auto';
    spin.src = spin.dataset.src;
    try{ spin.load(); }catch(e){}
  }
  /* autoplay refused (iOS Low Power Mode, data saver): start on the first touch/click anywhere */
  let spinArmed = false;
  function armSpin(){
    if (spinArmed) return; spinArmed = true;
    const go = ()=>{ ['pointerdown','touchstart','keydown'].forEach(t=> document.removeEventListener(t, go, true)); spinArmed = false; syncSpin(); };
    ['pointerdown','touchstart','keydown'].forEach(t=> document.addEventListener(t, go, { capture:true, passive:true }));
  }
  function syncSpin(){
    if (!spin || reduce) return;
    const want = idx === 0 && spinSeen && !document.hidden;
    if (want){
      spinLoad();
      const pr = spin.play(); if (pr && pr.catch) pr.catch(armSpin);
    } else if (spinLoaded && !spin.paused){ spin.pause(); }
  }
  if (spin && !reduce){
    if ('IntersectionObserver' in window){
      __io((es)=>{ es.forEach(e=>{ spinSeen = e.isIntersecting; }); syncSpin(); }, { rootMargin:'200px 0px' }).observe(stage);
    } else { spinSeen = true; }
    const kick = ()=> __sto(syncSpin, 150);
    if (document.readyState === 'complete') kick(); else __on(window, 'load', kick, { once:true });
    __on(document, 'visibilitychange', syncSpin);
  }
  document.getElementById('bbPrev').addEventListener('click', ()=> show(idx-1));
  document.getElementById('bbNext').addEventListener('click', ()=> show(idx+1));
  thumbs.forEach((t,k)=> t.addEventListener('click', ()=> show(k)));
  dots.forEach((d,k)=> d.addEventListener('click', ()=> show(k)));
  // keyboard arrows when the gallery has focus
  stage.addEventListener('keydown', (e)=>{
    if (e.key==='ArrowLeft'){ show(idx-1); e.preventDefault(); }
    else if (e.key==='ArrowRight'){ show(idx+1); e.preventDefault(); }
  });
  // touch swipe (no page-scroll hijack: only act on a mostly-horizontal gesture)
  let sx=0, sy=0, tracking=false;
  stage.addEventListener('touchstart', (e)=>{ const t=e.changedTouches[0]; sx=t.clientX; sy=t.clientY; tracking=true; }, {passive:true});
  stage.addEventListener('touchend', (e)=>{
    if (!tracking) return; tracking=false;
    const t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
    if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx<0?1:-1));
  }, {passive:true});

  /* ---- accordions (one open at a time) ---- */
  const heads = [...section.querySelectorAll('.bb__acc-head')];
  function setOpen(head, open){ head.setAttribute('aria-expanded', open ? 'true':'false'); }
  heads.forEach(head=>{
    head.addEventListener('click', ()=>{
      const isOpen = head.getAttribute('aria-expanded')==='true';
      heads.forEach(h=> setOpen(h, false));
      setOpen(head, !isOpen);
    });
  });
  // compatibility shortcut → open the first accordion and bring it into view
  document.getElementById('bbCompat').addEventListener('click', ()=>{
    heads.forEach(h=> setOpen(h, false));
    setOpen(heads[0], true);
    heads[0].scrollIntoView({ behavior: reduce ? 'auto':'smooth', block:'center' });
    heads[0].focus({ preventScroll:true });
  });

  /* ---- add to cart (polished front-end states; bind to Shopify /cart/add.js on port) ---- */
  const cta = document.getElementById('bbCta');
  const stickyCta = document.getElementById('bbStickyCta');
  const statusEl = document.getElementById('bbStatus');
  const available = section.dataset.available !== 'false';
  let busy = false;
  if (!available){ cta.disabled = true; cta.textContent = 'Sold Out'; if (stickyCta){ stickyCta.disabled = true; stickyCta.textContent = 'Sold Out'; } }

  function addToCart(){ return (window.__dropletCartAdd ? window.__dropletCartAdd() : Promise.reject(new Error('cart bridge unavailable'))); }
  function runPurchase(){
    if (busy || !available) return;
    busy = true;
    const label = cta.textContent;
    cta.dataset.state='loading'; cta.disabled=true; cta.textContent='Adding…';
    if (stickyCta){ stickyCta.disabled=true; stickyCta.textContent='Adding…'; }
    statusEl.textContent='Adding Droplet to your cart…';
    addToCart().then(()=>{
      cta.dataset.state='success'; cta.textContent='Added to Cart ✓';
      if (stickyCta) stickyCta.textContent='Added ✓';
      statusEl.textContent='Droplet added to your cart.';
      __sto(()=>{
        cta.dataset.state='default'; cta.disabled=false; cta.textContent=label;
        if (stickyCta){ stickyCta.disabled=false; stickyCta.textContent='Add to Cart'; }
        busy=false;
      }, 2200);
    }).catch(()=>{
      cta.dataset.state='default'; cta.disabled=false; cta.textContent=label;
      if (stickyCta){ stickyCta.disabled=false; stickyCta.textContent='Add to Cart'; }
      statusEl.textContent='Something went wrong, please try again.';
      busy=false;
    });
  }
  cta.addEventListener('click', runPurchase);
  if (stickyCta) stickyCta.addEventListener('click', runPurchase);

  /* ---- mobile sticky bar: show after the main CTA leaves view, while still in the buy box ---- */
  const sticky = document.getElementById('bbSticky');
  if (sticky && 'IntersectionObserver' in window){
    let ctaVisible = true, sectionVisible = false;
    const update = ()=>{
      const shouldShow = !ctaVisible && sectionVisible;
      sticky.classList.toggle('is-shown', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false':'true');
    };
    __io(([e])=>{ ctaVisible = e.isIntersecting; update(); }, { threshold:0 }).observe(cta);
    __io(([e])=>{ sectionVisible = e.isIntersecting; update(); },
      { threshold:0, rootMargin:'0px 0px -45% 0px' }).observe(section);
  }

  /* ---- entrance reveal ---- */
  if ('IntersectionObserver' in window){
    const io = __io((es)=>{ es.forEach(e=>{ if (e.isIntersecting){ section.classList.add('is-in'); io.disconnect(); } }); }, { threshold:0.12 });
    io.observe(section);
  } else { section.classList.add('is-in'); }
});

/* ---------- module 3 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const section = document.getElementById('ugc');
  if (!section) return;
  const reduce   = __mm('(prefers-reduced-motion: reduce)');
  const mqMobile = __mm('(max-width: 768px)');
  const track  = document.getElementById('ugcTrack');
  const cards  = [...section.querySelectorAll('.ugc__card')];
  const videos = cards.map(c => c.querySelector('video'));
  const sounds = cards.map(c => c.querySelector('.ugc__sound'));
  const plays  = cards.map(c => c.querySelector('.ugc__play'));
  const dots   = [...section.querySelectorAll('.ugc__dot')];
  const prevBtn = document.getElementById('ugcPrev');
  const nextBtn = document.getElementById('ugcNext');
  const statusEl = document.getElementById('ugcStatus');
  const N = videos.length;

  let audible = -1;     // index of the one audible video, -1 = all muted
  let active  = 0;      // mobile active (centered) slide
  let inView  = false;
  let hydrated = false;
  const isMobile = () => mqMobile.matches;
  const isReduced = () => reduce.matches;
  const setLabels = () => { const t = isMobile() ? 'Tap for sound' : 'Click for sound'; cards.forEach(c => { const l = c.querySelector('.ugc__sound-label'); if (l) l.textContent = t; }); };
  setLabels();

  function hydrate(){
    if (hydrated) return; hydrated = true;
    videos.forEach(v => { const s = v.getAttribute('data-src'); if (s && !v.src){ v.src = s; v.load(); } });
  }
  const play = v => { if (!v) return; const p = v.play(); if (p && p.catch) p.catch(()=>{}); };
  const stop = v => { if (v){ try { v.pause(); } catch(e){} } };

  function refreshPlayback(){
    if (!inView || isReduced()){ videos.forEach(stop); return; }
    hydrate();
    videos.forEach((v,i) => {
      const shouldPlay = isMobile() ? (i === active) : true;
      if (shouldPlay){ v.muted = (audible !== i); play(v); cards[i].classList.add('is-playing'); }
      else { stop(v); cards[i].classList.remove('is-playing'); v.muted = true; }
    });
  }

  function setAudible(i){
    audible = i;
    videos.forEach((v,k) => { v.muted = (k !== i); });
    sounds.forEach((b,k) => {
      const on = k === i;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Mute this video' : 'Turn on sound for this video');
      cards[k].classList.toggle('is-audible', on);
    });
    statusEl.textContent = i >= 0 ? `Sound on for video ${i+1}` : 'All videos muted';
  }
  function muteAll(){ setAudible(-1); }

  function toggleSound(i){
    section.classList.add('ugc--touched');                 // hide hint labels after first use
    hydrate();                                              // ensure source is loaded (covers reduced-motion)
    if (cards[i].classList.contains('needs-play')){         // reduced-motion: first interaction also plays
      play(videos[i]); cards[i].classList.add('is-playing'); cards[i].classList.remove('needs-play');
    }
    if (videos[i].paused) play(videos[i]);                  // ensure playing (do NOT restart / reset time)
    setAudible(audible === i ? -1 : i);
  }

  /* card interactions — tap toggles sound, guarded against swipe */
  cards.forEach((card, i) => {
    let moved = false, sx = 0, sy = 0;
    card.addEventListener('pointerdown', e => { moved = false; sx = e.clientX; sy = e.clientY; }, { passive:true });
    card.addEventListener('pointermove', e => { if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) moved = true; }, { passive:true });
    card.addEventListener('click', e => {
      if (moved) return;                                    // was a swipe / scroll, not a tap
      if (e.target.closest('.ugc__sound') || e.target.closest('.ugc__play')) return;
      toggleSound(i);
    });
    sounds[i].addEventListener('click', e => { e.stopPropagation(); toggleSound(i); });
    plays[i].addEventListener('click', e => {
      e.stopPropagation();
      hydrate();
      play(videos[i]); cards[i].classList.add('is-playing'); cards[i].classList.remove('needs-play');
    });
  });

  /* mobile: detect the centred slide (scroll-snap) */
  function setActive(i){
    if (i === active) return;
    active = i;
    muteAll();                                              // navigating away mutes the previous
    dots.forEach((d,k)=>{ d.classList.toggle('is-active', k===i); d.setAttribute('aria-selected', k===i?'true':'false'); });
    prevBtn.hidden = (i === 0);
    nextBtn.hidden = (i === N - 1);
    refreshPlayback();
  }
  if ('IntersectionObserver' in window){
    const cardIO = __io((entries) => {
      if (!isMobile()) return;
      let best = null;
      entries.forEach(e => { if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e; });
      if (best && best.intersectionRatio >= 0.6) setActive(cards.indexOf(best.target));
    }, { root: track, threshold:[0.6, 0.9] });
    cards.forEach(c => cardIO.observe(c));
  }
  const goTo = i => { i = Math.max(0, Math.min(N-1, i)); cards[i].scrollIntoView({ behavior: isReduced() ? 'auto' : 'smooth', inline:'center', block:'nearest' }); };
  const gapPx = () => parseFloat(getComputedStyle(track).columnGap) || 14;
  const pageBy = dir => track.scrollBy({ left: dir * (cards[0].getBoundingClientRect().width + gapPx()), behavior: isReduced() ? 'auto' : 'smooth' });
  function syncArrows(){ if (isMobile()) return; const max = track.scrollWidth - track.clientWidth; prevBtn.hidden = track.scrollLeft <= 2; nextBtn.hidden = track.scrollLeft >= max - 2; }
  nextBtn.addEventListener('click', () => { if (!isMobile()){ pageBy(1); return; } goTo(active + 1); });
  prevBtn.addEventListener('click', () => { if (!isMobile()){ pageBy(-1); return; } goTo(active - 1); });
  track.addEventListener('scroll', () => { if (!isMobile()) __raf(syncArrows); }, { passive:true });
  syncArrows();
  dots.forEach((d,i) => d.addEventListener('click', () => goTo(i)));

  /* section visibility → start / stop playback; reduced motion → posters + play buttons */
  function applyReduced(){ if (isReduced()){ videos.forEach((v,i)=> cards[i].classList.add('needs-play')); } }
  applyReduced();
  if ('IntersectionObserver' in window){
    __io(([e]) => {
      inView = e.isIntersecting;
      if (inView){ section.classList.add('is-in'); refreshPlayback(); }
      else { videos.forEach(stop); muteAll(); }
    }, { threshold:0.25 }).observe(section);
  } else { inView = true; section.classList.add('is-in'); refreshPlayback(); }

  /* re-evaluate when crossing the breakpoint */
  const onBP = () => { setLabels(); refreshPlayback(); syncArrows(); };
  (mqMobile.addEventListener ? mqMobile.addEventListener('change', onBP) : mqMobile.addListener(onBP));

  /* background fades white -> dark in exact lockstep with the scroll section's fade-to-black.
     Replicates that section's own curve (easeOutCubic of exitProgress/0.55) read from #hero,
     so the two backgrounds darken together. rAF-throttled; reduced motion keeps it dark. */
  const fade = document.getElementById('ugcFade');
  const heroEl = document.getElementById('hero');
  const lpRoot = document.querySelector('[data-droplet-lp]');
  const lpB = !!(lpRoot && lpRoot.getAttribute('data-layout') === 'b');
  const clampN = (v,a,b) => Math.min(Math.max(v,a),b);
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
  let fadeRaf = 0;
  function syncFade(){
    fadeRaf = 0;
    if (!fade) return;
    if (isReduced()){ fade.style.opacity = '0'; return; }
    let dark = 0;
    if (lpB){
      /* Option B: the buy box sits above, so the fade keys off this section's own
         entrance. Same curve as below: on the standard page this section's top
         rides the hero's bottom edge, so (1 - top / viewport) is the hero's
         exit progress. */
      const entry = clampN(1 - section.getBoundingClientRect().top / window.innerHeight, 0, 1);
      dark = easeOutCubic(clampN(entry / 0.55, 0, 1));
    } else if (heroEl){
      const range = heroEl.offsetHeight - window.innerHeight;
      if (range > 0){
        const rectTop = heroEl.getBoundingClientRect().top;
        const exitProgress = clampN((-rectTop - range) / window.innerHeight, 0, 1);
        dark = easeOutCubic(clampN(exitProgress / 0.55, 0, 1));
      }
    }
    fade.style.opacity = (1 - dark).toFixed(3);     // white on top while bright, clears as it goes black
  }
  const queueFade = () => { if (!fadeRaf) fadeRaf = __raf(syncFade); };
  syncFade();
  __on(window, 'scroll', queueFade, { passive:true });
  __on(window, 'resize', queueFade, { passive:true });
  if (reduce.addEventListener) reduce.addEventListener('change', () => { applyReduced(); refreshPlayback(); });

  /* tab hidden → pause (kills any audio); return / bfcache restore → re-sync the
     scroll-linked background fade and resume in-view playback (pageshow covers
     Safari bfcache restores where visibilitychange may not fire) */
  function onReturn(){
    if (document.hidden){ videos.forEach(stop); return; }
    queueFade();
    if (inView) refreshPlayback();
  }
  __on(document, 'visibilitychange', onReturn);
  __on(window, 'pageshow', onReturn);
});

/* ---------- module 4 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const section = document.getElementById('appdemo');
  if (!section) return;
  const phone   = document.getElementById('appPhone');
  const vidA    = document.getElementById('appVidA');   // desktop alert
  const vidB    = document.getElementById('appVidB');   // desktop usage
  const vidAm   = document.getElementById('appVidAm');  // mobile alert
  const vidBm   = document.getElementById('appVidBm');  // mobile usage
  const glow    = section.querySelector('.app__glow');
  const chapters= Array.prototype.slice.call(section.querySelectorAll('.app__chapter'));
  const dots    = Array.prototype.slice.call(section.querySelectorAll('.app__dot'));
  const coNotif = document.getElementById('coNotif');
  const coMetr  = document.getElementById('coMetrics');
  const coRange = document.getElementById('coRanges');
  const coFix   = document.getElementById('coFixtures');
  const mqMobile= __mm('(max-width: 768px)');
  const reduce  = __mm('(prefers-reduced-motion: reduce)');

  const clamp=(v,a,b)=>Math.min(Math.max(v,a),b);
  const ease =t=>1-Math.pow(1-t,3);
  const band =(p,a,b,c,d)=> (p<=a||p>=d)?0 : p<b?(p-a)/(b-a) : p>c?1-(p-c)/(d-c) : 1;
  const b01  =(p,a,b)=>clamp((p-a)/(b-a),0,1);
  const lerp =(a,b,t)=>a+(b-a)*t;
  const eio  =t=>{ t=clamp(t,0,1); return t*t*(3-2*t); };   // restrained inOut (smoothstep) for the drop

  if (reduce.matches) return;   // static fallback handled in CSS; no scrub loop

  /* per-video scrubber: coalesced seeking + watchdog (same approach as #hero) */
  function makeScrubber(v){
    let dur=0, ready=false, full=false, last=-1, busy=false, start=0, pend=null, loaded=false, primed=false;
    function vinit(){ if(!ready && v.duration && isFinite(v.duration) && v.duration>0){ dur=v.duration; ready=true; } }
    ['loadedmetadata','durationchange','canplay'].forEach(e=>v.addEventListener(e,vinit));
    v.addEventListener('progress',()=>{ try{ if(v.buffered.length && v.buffered.end(v.buffered.length-1) >= (v.duration||1)-0.1) full=true; }catch(e){} });
    v.addEventListener('seeked',()=>{ busy=false; if(pend!=null){ const t=pend; pend=null; seek(t); } });
    /* wake the decode pipeline so a paused video paints seeked frames (Safari, esp. desktop) */
    function prime(){ if(primed || !v.src) return; primed=true;
      try{ const pr=v.play(); if(pr&&pr.then) pr.then(()=>v.pause()).catch(()=>{}); else v.pause(); }catch(e){} }
    v.addEventListener('loadeddata', prime);
    if(v.readyState>=1) vinit();
    function bend(){ try{ return v.buffered.length? v.buffered.end(v.buffered.length-1):0; }catch(e){ return dur; } }
    function seek(t){
      if(!ready) return;
      t=clamp(t,0,dur-0.05);
      if(!full){ const safe=bend()-0.1; if(safe>0 && t>safe) t=safe; }
      if(busy){ pend=t; return; }
      if(Math.abs(t-last)<0.012) return;
      last=t; busy=true; start=performance.now();
      if(v.fastSeek){ try{ v.fastSeek(t); }catch(e){ v.currentTime=t; } } else v.currentTime=t;
    }
    return {
      seek:seek, prime:prime,
      tick(){ if(busy && performance.now()-start>250) busy=false; },
      /* tab-return / bfcache: clear an in-flight seek, defeat the "negligible move" skip so the
         next seek actually repaints, and re-arm the one-shot decoder prime so it wakes again */
      wake(){ busy=false; last=-1; primed=false; prime(); },
      load(){ if(loaded) return; loaded=true; if(v.dataset.src && !v.src) v.src=v.dataset.src; try{ v.load(); }catch(e){} },
      get ready(){ return ready; }, get dur(){ return dur; }
    };
  }
  const scA=makeScrubber(vidA), scB=makeScrubber(vidB);
  const scAm=makeScrubber(vidAm), scBm=makeScrubber(vidBm);

  /* prime decoders on the first real user gesture too — desktop Safari won't paint a
     scrubbed (paused) video until its pipeline is woken (this is what #hero does) */
  const primeAll=()=>{ scA.prime(); scB.prime(); scAm.prime(); scBm.prime(); };
  ['pointerdown','touchstart','wheel','keydown'].forEach(e=>
    __on(window, e, primeAll, { passive:true }));

  /* video-time maps — identical content/timing on both desktop & mobile assets.
     A deliberate hold sits on the notification, ~p .07–.22 */
  function aTime(p){
    /* Re-anchored for app-alert (2026-07 take, 6.70s). Scene detection puts the
       notification cut at 1.53-1.70s (it was 1.10-1.17s before), then this take
       scrolls continuously from 2.60s to 6.40s rather than jump-cutting. */
    if(p<=0.07) return lerp(0,1.15, p/0.07);
    if(p<=0.22) return lerp(1.15,1.50,(p-0.07)/0.15);  // hold just before the cut
    if(p<=0.28) return lerp(1.50,1.95,(p-0.22)/0.06);  // through the cut
    return lerp(1.95,6.55, clamp((p-0.28)/0.24,0,1));  // the continuous scroll
  }
  /* App dashboard (2026-10 take, droplet-app-dashboard, 20.93s, all-intra).
     Its beats, from scene review: 0-2.0s Today; 2.0-4.4s scrolling back through
     the day; 4.4-12.6s Hour view, the live flow followed minute by minute;
     12.6-14.6s This year; 14.6-16.6s July; 16.6-18.2s scrolling down to
     "What's using water"; 18.2s-end the fixture list. Chapter 3 ("this minute
     to this year") gets the day, the live minute and the year/month zoom;
     chapter 4 gets the list, held at the end. KEYS map story p -> film time. */
  const B_KEYS=[[0.50,0],[0.535,1.6],[0.60,4.4],[0.665,12.6],[0.70,14.6],[0.735,16.6],[0.80,18.2],[0.92,20.85],[1.00,20.9]];
  function bTime(p, sc){
    const end = (sc && sc.dur) ? sc.dur : 20.93;
    if(p<=B_KEYS[0][0]) return 0;
    for(let i=1;i<B_KEYS.length;i++){
      const a=B_KEYS[i-1], b=B_KEYS[i];
      if(p<=b[0]) return Math.min(end, lerp(a[1], b[1], (p-a[0])/(b[0]-a[0])));
    }
    return Math.min(end, B_KEYS[B_KEYS.length-1][1]);
  }
  /* the range callout follows the film: the selector the app has on screen is the one lit */
  const R_AT=[['day',0],['hour',4.4],['year',12.6],['month',14.6]];
  const rOpts=coRange ? Array.prototype.slice.call(coRange.querySelectorAll('[data-r]')) : [];
  let rKey='';
  function syncRange(t){
    let k='day'; R_AT.forEach(r=>{ if(t>=r[1]) k=r[0]; });
    if(k===rKey) return; rKey=k;
    rOpts.forEach(o=>o.classList.toggle('is-on', o.getAttribute('data-r')===k));
  }

  function revealCo(el, v, mob){
    el.style.opacity=v.toFixed(3);
    if(mob) el.style.transform='translateY('+((1-v)*0.7).toFixed(2)+'rem)';
    else    el.style.transform='translate('+((1-v)*1.4).toFixed(2)+'rem, calc(-50% + '+((1-v)*0.5).toFixed(2)+'rem))';
  }
  /* notification: matched-geometry-ish extract — scales up from near the phone, then settles */
  function revealNotif(el, v, mob){
    el.style.opacity=v.toFixed(3);
    const s=lerp(0.92,1, ease(v));
    if(mob) el.style.transform='translateY('+((1-v)*1.1).toFixed(2)+'rem) scale('+s.toFixed(4)+')';
    else    el.style.transform='translate('+((1-v)*-1.9).toFixed(2)+'rem, calc(-50% + '+((1-v)*0.3).toFixed(2)+'rem)) scale('+s.toFixed(4)+')';
  }

  let target=0, cur=0, started=false, bReq=false;
  function computeTarget(){
    const range=section.offsetHeight - window.innerHeight;
    const top=section.getBoundingClientRect().top;
    target = range>0 ? clamp(-top/range,0,1) : 0;
  }
  __on(window, 'scroll', computeTarget, {passive:true});
  __on(window, 'resize', computeTarget);
  computeTarget();

  /* MOBILE entrance geometry — the phone drops from just below the first heading to its
     existing resting spot. tyStartVh is derived from real layout, so it is responsive
     (no fixed px) and the final resting position is never changed. */
  const stage=section.querySelector('.app__stage');
  let tyStartVh=-28;
  function topWithin(el){ let y=0,n=el; while(n && n!==stage){ y+=n.offsetTop; n=n.offsetParent; } return y; }
  function computeEntrance(){
    if(!mqMobile.matches || !stage || !chapters[0]) return;
    const L=topWithin(phone);                                   // phone layout top (transform-independent)
    const hb=topWithin(chapters[0])+chapters[0].offsetHeight;   // bottom of the heading+copy block
    const gap=Math.max(12, window.innerHeight*0.02);
    tyStartVh=clamp(((hb+gap)-L)/window.innerHeight*100, -60, -10);  // upward offset, in vh
  }
  computeEntrance();
  __on(window, 'resize', computeEntrance);

  /* init only as the section approaches — keeps clear of hero/scroll/UGC video work */
  __io((es)=>{
    es.forEach(e=>{ if(e.isIntersecting && !started){ started=true; (mqMobile.matches?scAm:scA).load(); } });
  }, { rootMargin:'150% 0px 150% 0px', threshold:0 }).observe(section);

  /* breakpoint change → make sure the now-active pair is loaded */
  const onBP=()=>{ computeEntrance(); if(!started) return; const m=mqMobile.matches; (m?scAm:scA).load(); if(bReq)(m?scBm:scB).load(); };
  (mqMobile.addEventListener ? mqMobile.addEventListener('change',onBP) : mqMobile.addListener(onBP));

  /* tab switch / bfcache restore: while hidden the decoder is suspended and rAF is paused, so a
     paused (scrubbed) video can stay frozen on a stale frame and the next seek can be skipped as
     a "negligible move". Safari also won't wake a decoder for an OFFSCREEN video, so instead of
     waking here, flag it — the rAF loop performs the wake once the section is near the viewport
     (it already idles when far away), which is exactly when Safari will honour it. */
  let needsWake=false;
  function doWake(){
    const m=mqMobile.matches;
    (m?scAm:scA).wake();
    if(bReq)(m?scBm:scB).wake();
    computeTarget();
  }
  function onVisible(){
    if(document.hidden) return;
    needsWake=true;
  }
  __on(document, 'visibilitychange', onVisible);
  __on(window, 'pageshow', onVisible);

  const CW=[ [0.00,0.03,0.22,0.28],[0.26,0.31,0.46,0.52],[0.50,0.55,0.68,0.74],[0.72,0.77,0.95,1.00] ];
  const PW=[ [0.005,0.025,0.115,0.14],[0.27,0.29,0.38,0.405],[0.505,0.525,0.60,0.625],[0.725,0.745,0.82,0.845] ]; // mobile copy holds longer, then hands off to its callout
  const CSTART=[0.0,0.30,0.52,0.74];

  function loop(){
    __raf(loop);
    if(!started) return;
    const r=section.getBoundingClientRect();
    if(r.bottom < -window.innerHeight || r.top > 2*window.innerHeight) return;  // far away → idle
    if(needsWake){ needsWake=false; doWake(); }   // deferred tab-return wake, now that Safari will honour it

    cur += (target-cur)*0.10;
    const p=cur, mob=mqMobile.matches;

    /* MOBILE pre-entry: the phone drop is tied to the section ENTERING the viewport
       (its top travels viewport-bottom → viewport-top / pin), NOT the pinned story
       timeline. entry reaches 1 exactly when the stage pins — where story p begins at 0,
       so the very next scroll advances the video with no dead range. */
    const vh=window.innerHeight;
    const entry = mob ? clamp((vh - r.top)/vh, 0, 1) : 1;

    if(!bReq && p>0.20){ bReq=true; (mob?scBm:scB).load(); }

    /* scrub the active (desktop|mobile) pair; crossfade alert→usage at ~p .50.
       During the mobile drop p===0, so the first video stays locked on frame 0. */
    const va=mob?vidAm:vidA, vb=mob?vidBm:vidB, sa=mob?scAm:scA, sb=mob?scBm:scB;
    sa.tick(); sb.tick();
    const bo=clamp((p-0.50)/0.04,0,1), ao=1-bo;
    if(ao>0.01 && sa.ready) sa.seek(aTime(p));
    const tB=bTime(p, sb);
    if(bo>0.01 && sb.ready) sb.seek(tB);
    syncRange(tB);
    va.style.opacity=ao.toFixed(3);
    vb.style.opacity=bo.toFixed(3);

    /* chapter headlines (+ mobile intro copy that fades before its callout) */
    chapters.forEach((el,i)=>{
      let v, dy;
      if(mob && i===0){
        /* first heading appears during the drop and holds — stable & readable while the
           phone clears it — then exits on its normal story window (no boundary flash) */
        const rise=eio(clamp((entry-0.45)/0.55,0,1));
        const fall=1-clamp((p-CW[0][2])/(CW[0][3]-CW[0][2]),0,1);
        v=rise*fall; dy=(1-rise)*0.7;
      } else {
        v=band(p, CW[i][0],CW[i][1],CW[i][2],CW[i][3]);
        dy=(1-v)*(mob?0.7:0.6);
      }
      el.style.opacity=v.toFixed(3);
      el.style.transform = mob ? 'translateY('+dy.toFixed(2)+'rem)' : 'translateY(calc(-50% + '+dy.toFixed(2)+'rem))';
      const cp=el.querySelector('p');
      if(cp){
        if(mob && i===0){
          const rise=eio(clamp((entry-0.45)/0.55,0,1));
          const fall=1-clamp((p-PW[0][2])/(PW[0][3]-PW[0][2]),0,1);
          cp.style.opacity=(rise*fall).toFixed(3);
        } else cp.style.opacity = mob ? band(p,PW[i][0],PW[i][1],PW[i][2],PW[i][3]).toFixed(3) : '1';
      }
    });

    /* callouts — one dominant at a time. Mobile starts each callout later so the
       sub-heading before it holds longer; desktop timing is unchanged. */
    const NW = mob?[0.14,0.185,0.245,0.28]:[0.07,0.12,0.24,0.28];
    const MW = mob?[0.405,0.44,0.48,0.52]:[0.34,0.39,0.48,0.52];
    const RW = mob?[0.625,0.655,0.69,0.74]:[0.56,0.61,0.69,0.74];
    const FW = mob?[0.845,0.875,0.96,1.00]:[0.79,0.84,0.96,1.00];
    const vN=band(p,NW[0],NW[1],NW[2],NW[3]);
    const vM=band(p,MW[0],MW[1],MW[2],MW[3]);
    const vR=band(p,RW[0],RW[1],RW[2],RW[3]);
    const vF=band(p,FW[0],FW[1],FW[2],FW[3]);
    revealNotif(coNotif, vN, mob);
    revealCo(coMetr,  vM, mob);
    revealCo(coRange, vR, mob);
    revealCo(coFix,   vF, mob);

    /* phone transform — ONE source of truth.
       Mobile: the pre-entry drop offset (entry) blends into the existing story settle (p);
       at entry===1 the offset is exactly 0, so it matches the story position with no jump. */
    if(mob){
      const cpres=Math.max(vN,vM,vR,vF);          // any callout present?
      const storyTy=lerp(-1.0,0, cpres);          // existing bottom-anchored settle
      const sc=lerp(1.0,0.965, cpres);            // existing slight shrink for callout room
      const entOff=lerp(tyStartVh+1, 0, eio(entry)); // pre-entry drop: high → 0 (the +1 cancels storyTy at p=0)
      const ty=entOff+storyTy;
      phone.style.transform='translateX(-50%) translateY('+ty.toFixed(2)+'vh) scale('+sc.toFixed(4)+')';
    } else {
      const ty=lerp(3,0, ease(b01(p,0,0.05)));    // desktop: gentle settle (unchanged)
      phone.style.transform='translate(-50%, calc(-50% + '+ty.toFixed(2)+'vh)) scale(1)';
    }

    glow.style.opacity=(0.55*band(p,0.02,0.14,0.9,1.0)).toFixed(3);

    let bi=0; for(let i=CSTART.length-1;i>=0;i--){ if(p>=CSTART[i]){ bi=i; break; } }
    dots.forEach((d,i)=>d.classList.toggle('is-on', i===bi));
  }
  __raf(loop);
});

/* ---------- module 5 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const section = document.getElementById('finalcta');
  if(!section) return;
  const img   = document.getElementById('finImg');
  const glow  = document.getElementById('finGlow');
  const reduce= __mm('(prefers-reduced-motion: reduce)');
  const clamp = (v,a,b)=>Math.min(Math.max(v,a),b);
  const ease  = t=>1-Math.pow(1-t,3);                       // easeOutCubic — matches the rest of the page

  /* price: single source of truth — mirror the live buy-box price rather than hard-coding */
  const priceSrc = document.querySelector('.bb__price-now');
  const priceEl  = document.getElementById('finPrice');
  if(priceSrc && priceEl){ const t=priceSrc.textContent.trim(); if(t) priceEl.textContent=t; }

  /* primary CTA — same front-end states as the buy box (bind to Shopify /cart/add.js at the integration point) */
  const cta    = document.getElementById('finCta');
  const status = document.getElementById('finStatus');
  const available = (document.getElementById('buybox')||{dataset:{}}).dataset.available !== 'false';
  let busy=false;
  if(!available && cta){ cta.disabled=true; cta.textContent='Sold Out'; }
  function addToCart(){ return (window.__dropletCartAdd ? window.__dropletCartAdd() : Promise.reject(new Error('cart bridge unavailable'))); }
  if(cta) cta.addEventListener('click', ()=>{
    if(busy || !available) return; busy=true;
    const label=cta.textContent;
    cta.dataset.state='loading'; cta.disabled=true; cta.textContent='Adding…';
    if(status) status.textContent='Adding Droplet to your cart…';
    addToCart().then(()=>{
      cta.dataset.state='success'; cta.textContent='Added to Cart ✓';
      if(status) status.textContent='Droplet added to your cart.';
      __sto(()=>{ cta.dataset.state='default'; cta.disabled=false; cta.textContent=label; busy=false; },2200);
    }).catch(()=>{ cta.dataset.state='default'; cta.disabled=false; cta.textContent=label;
      if(status) status.textContent='Something went wrong, please try again.'; busy=false; });
  });

  /* compatibility — reuse the buy box's established action */
  const compat=document.getElementById('finCompat');
  if(compat) compat.addEventListener('click', ()=>{ const b=document.getElementById('bbCompat'); if(b) b.click(); });

  /* reduced motion: image at full strength immediately, no scrub */
  function applyFull(){ if(img) img.style.opacity='1'; if(glow) glow.style.opacity='0.4'; }
  if(reduce.matches){ applyFull(); return; }

  /* scroll-driven light-up: opacity 0→1 across the section's entrance, glow secondary; reverses on scroll-up */
  let target=0, cur=0, raf=0;
  function compute(){
    const vh=window.innerHeight || document.documentElement.clientHeight;
    const top=section.getBoundingClientRect().top;
    const start=vh*0.92, end=vh*0.42;                       // 0 as it approaches → 1 once it's well into view
    target=clamp((start-top)/(start-end),0,1);
  }
  function loop(){
    cur += (target-cur)*0.12;
    const e=ease(clamp(cur,0,1));
    if(img)  img.style.opacity=e.toFixed(3);
    if(glow) glow.style.opacity=(ease(clamp((cur-0.12)/0.88,0,1))*0.42).toFixed(3);  // restrained, lags the opacity
    if(Math.abs(target-cur)>0.0015){ raf=__raf(loop); } else { cur=target; raf=0; }
  }
  const kick=()=>{ compute(); if(!raf) raf=__raf(loop); };
  __on(window, 'scroll', kick, {passive:true});
  __on(window, 'resize', kick);
  /* tab return / bfcache restore: recompute against the restored scroll position and
     restart the easing loop (rAF was frozen while hidden; styles persist across bfcache) */
  __on(document, 'visibilitychange', ()=>{ if(!document.hidden) kick(); });
  __on(window, 'pageshow', kick);
  kick();
  reduce.addEventListener && reduce.addEventListener('change', e=>{ if(e.matches){ if(raf){__craf(raf); raf=0;} applyFull(); } });
});

/* ---------- module 6 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  var v=document.getElementById('finImg');
  if(!v || v.tagName!=='VIDEO') return;
  v.muted=true;                                   // required for reliable mobile autoplay
  var reduce=__mm('(prefers-reduced-motion: reduce)');
  var inview=false;

  /* The markup ships data-src, not src — the file is ~5.1MB and used to be
     fetched during initial page load for a section nobody had scrolled to yet.
     Same shape as hydrate() in module 1: attach once, then let it buffer. */
  function hydrate(){
    if(v.dataset.loaded) return;
    var s=v.getAttribute('data-src');
    if(!s) return;                                // nothing wired in the section settings
    v.src=s; v.dataset.loaded='1';
    try{ v.load(); }catch(_){}
  }
  /* play() before the source has decoded a frame rejects on some browsers, so
     wait for loadeddata when it isn't ready yet. */
  function tryPlay(){
    hydrate();
    if(v.readyState<2){ v.addEventListener('loadeddata', tryPlay, {once:true}); return; }
    var p=v.play(); if(p&&typeof p.catch==='function') p.catch(function(){});   // swallow autoplay rejections
  }

  if(reduce.matches){ v.removeAttribute('autoplay'); try{ v.pause(); }catch(e){} }   // hold a stable frame (poster shows)
  else if('IntersectionObserver' in window){
    /* Two observers, deliberately. Module 5 fades this element up from
       opacity:0 starting when the section is ~0.92vh away, so if buffering only
       began at the play gate the fade would reveal a stalled poster. Buffering
       starts a full viewport-and-a-half early; play/pause keeps the original
       200px gate so nothing autoplays off-screen. */
    var pio=__io(function(es){
      if(es.some(function(e){ return e.isIntersecting; })){ hydrate(); pio.disconnect(); }
    },{rootMargin:'1500px 0px'});
    pio.observe(v);

    var io=__io(function(es){
      es.forEach(function(e){
        inview=e.isIntersecting;
        if(e.isIntersecting) tryPlay();
        else try{ v.pause(); }catch(_){}          // pause preserves currentTime — no restart from frame 0
      });
    },{rootMargin:'200px 0px'});                  // start a touch before it enters, pause once well past
    io.observe(v);
  } else { inview=true; tryPlay(); }

  /* tab return / bfcache restore: muted autoplay is often left paused (esp. Safari) and
     visibilitychange isn't guaranteed on bfcache restores — resume when back in view */
  function wakeFin(){ if(!document.hidden && inview && !reduce.matches) tryPlay(); }
  __on(document, 'visibilitychange', wakeFin);
  __on(window, 'pageshow', wakeFin);

  reduce.addEventListener && reduce.addEventListener('change', function(e){
    if(e.matches){ try{ v.pause(); }catch(_){} } else { tryPlay(); }
  });
});

/* ---------- module 7 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const section=document.getElementById('press'); if(!section) return;
  const row=document.getElementById('pressRow');
  const setA=row && row.querySelector('.press__set'); if(!setA) return;
  const reduce=__mm('(prefers-reduced-motion: reduce)');
  const mqMarquee=__mm('(max-width:1000px)');

  /* staggered entrance reveal (desktop) / gentle fade (marquee) */
  if('IntersectionObserver' in window){
    const io=__io(es=>es.forEach(e=>{ if(e.isIntersecting){ section.classList.add('is-in'); io.disconnect(); } }),{threshold:.25});
    io.observe(section);
  } else { section.classList.add('is-in'); }

  /* clone the set once (aria-hidden) so the marquee can loop seamlessly */
  let dup=null;
  function ensureDup(){
    if(dup) return;
    dup=setA.cloneNode(true);
    dup.setAttribute('aria-hidden','true');
    dup.removeAttribute('role');
    dup.classList.add('press__set--dup');
    dup.querySelectorAll('a').forEach(a=>{ a.tabIndex=-1; });
    row.appendChild(dup);
  }
  /* keep a constant, cinematic speed regardless of track width (28–40s) */
  function setDuration(){
    if(reduce.matches) return;
    const w=setA.getBoundingClientRect().width; if(!w) return;
    let dur=w/58;                       // ~58px per second
    dur=Math.max(28,Math.min(40,dur));
    section.style.setProperty('--marq-dur', dur.toFixed(1)+'s');
  }
  function syncMode(){ if(!reduce.matches){ ensureDup(); setDuration(); } }
  syncMode();

  let rt; __on(window, 'resize',()=>{ __cto(rt); rt=__sto(setDuration,200); },{passive:true});
  mqMarquee.addEventListener && mqMarquee.addEventListener('change', syncMode);

  /* pause: tab hidden, or while the visitor is touching/holding the track */
  __on(document, 'visibilitychange',()=>{ section.classList.toggle('is-paused', document.hidden); });
  /* bfcache restore: visibilitychange isn't guaranteed — re-sync paused state + speed */
  __on(window, 'pageshow',()=>{ section.classList.toggle('is-paused', document.hidden); setDuration(); });
  let resume; 
  section.addEventListener('pointerdown',()=>{ __cto(resume); section.classList.add('is-paused'); },{passive:true});
  __on(window, 'pointerup',()=>{ __cto(resume); resume=__sto(()=>section.classList.remove('is-paused'),600); },{passive:true});
});

/* ---------- module 8 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  var sec=document.getElementById('compare'); if(!sec) return;

  /* ---- single source of truth ---- */

  /* Section bridge: comparison images + merchant-editable table config. */
  var CMPIMG = (function(){
    try { var e=document.getElementById('dropletCmpImages');
          return e ? JSON.parse(e.textContent) : {}; } catch(x){ return {}; }
  })();
  var CFG_OVERRIDE = (function(){
    try { var e=document.getElementById('dropletCmpConfig');
          if(!e || !e.textContent.trim()) return null;
          var p=JSON.parse(e.textContent);
          return (p && p.products && p.groups) ? p : null; }
    catch(x){ if(window.console&&console.warn)
                console.warn('[droplet-lp] comparison table JSON is invalid, using the built-in table.', x);
              return null; }
  })();
  var CFG={
    products:[
      {id:'droplet', name:'Droplet', featured:true},
      {id:'meter',   name:'Straps on to Meter', short:'Meter-mounted'},
      {id:'inline',  name:'In-Line Shutoff',   short:'In-line shutoff'}
    ],
    groups:[
      {title:'Cost & ownership', features:[
        {label:'Price', values:{
          droplet:{kind:'val', big:'$229'},
          meter:  {kind:'val', big:'$269'},
          inline: {kind:'val', big:'$623.99+', sub:'plus plumber install'} }},
        {label:'Subscription', values:{
          droplet:{kind:'yes', big:'Never'},
          meter:  {kind:'yes', big:'Never'},
          inline: {kind:'no',  big:'Optional paid plan'} }}
      ]},
      {title:'Detection', features:[
        {label:'Readings per minute', values:{
          droplet:{kind:'val', big:'3,000+', sub:'50+ readings per second'},
          meter:  {kind:'val', big:'12',   sub:'one every 5 seconds'},
          inline: {kind:'val', big:'60',   sub:'one per second'} }},
        {label:'Smallest flow it can detect', values:{
          droplet:{kind:'val', big:'Best',              sub:'0.026 gpm, real-time'},
          meter:  {kind:'val', big:'Varies',            sub:'0.01–0.07 gpm, meter dependent'},
          inline: {kind:'val', big:'Misses small flows', sub:'real-time only above 0.10 gpm'} }},
        {label:'Time to alert to smallest flows', values:{
          droplet:{kind:'val', big:'Minutes',   sub:'5 min at defaults'},
          meter:  {kind:'val', big:'2+ hours',  sub:'2-hr default before alerting'},
          inline: {kind:'val', big:'Overnight', sub:'nightly test for flows under 0.10 gpm'} }}
      ]},
      {title:'Installation & compatibility', features:[
        {label:'Easy install, no plumber', values:{
          droplet:{kind:'yes', big:'Yes', sub:'clamps on your pipe in seconds'},
          meter:  {kind:'yes', big:'Yes', sub:'about 10-15 minutes, depends on your meter'},
          inline: {kind:'no',  big:'No',  sub:'professional plumber required'} }},
        {label:'Works on well water without a meter', values:{
          droplet:{kind:'yes', big:'Yes'},
          meter:  {kind:'no',  big:'No'},
          inline: {kind:'yes', big:'Yes'} }}
      ]},
      {title:'Operation & control', features:[
        {label:'Always on, not battery powered', values:{
          droplet:{kind:'yes', big:'Yes'},
          meter:  {kind:'no',  big:'Battery'},
          inline: {kind:'yes', big:'Yes'} }},
        {label:'Automatic shut-off', values:{
          droplet:{kind:'cond', big:'With integrations', sub:'Home Assistant • MQTT'},
          meter:  {kind:'cond', big:'With integrations', sub:'varies by product'},
          inline: {kind:'yes',  big:'Yes', sub:'built-in'} }}
      ]}
    ]
  };

  if (CFG_OVERRIDE) CFG = CFG_OVERRIDE;

  var ICON={
    yes :'<svg class="cmp__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M4 12.6l5 5 11-12"/></svg>',
    no  :'<svg class="cmp__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" d="M5 12h14"/></svg>',
    cond:'<svg class="cmp__ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.2" fill="none" stroke="currentColor" stroke-width="2.1"/><circle cx="12" cy="12" r="2.7" fill="currentColor"/></svg>'
  };
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function cellHTML(pid,v){
    var k=v.kind, kc = k==='yes'?'cmp__yes':k==='no'?'cmp__no':k==='cond'?'cmp__cond':'cmp__val';
    var ic = k==='yes'?ICON.yes:k==='cond'?ICON.cond:'';   /* dash glyph removed from 'no' cells per client feedback */
    var big='<span class="cmp__big">'+ic+'<span>'+esc(v.big)+'</span></span>';
    var sub=v.sub?'<span class="cmp__sub">'+esc(v.sub)+'</span>':'';
    return '<div class="cmp__cell cmp__cell--'+pid+' '+kc+'">'+big+sub+'</div>';
  }

  /* ---- summary bento ---- */
  var sum=document.getElementById('cmpSummary');
  if(sum){
    sum.innerHTML=
      '<div class="cmp__summary-line">$229. <b>Five-minute installation.</b> No subscription.</div>'+
      '<div class="cmp__stats">'+
        '<div class="cmp__stat"><b>$229</b><span>One-time purchase</span></div>'+
        '<div class="cmp__stat"><b>+50×</b><span>Readings per second</span></div>'+
        '<div class="cmp__stat"><b>5 min</b><span>Typical installation</span></div>'+
      '</div>';
  }

  /* ---- visual stack: product headers + panels ---- */
  var stack=document.getElementById('cmpStack');
  var altDefault = sec.getAttribute('data-alt') || 'meter';
  function prod(id){ for(var i=0;i<CFG.products.length;i++) if(CFG.products[i].id===id) return CFG.products[i]; }
  if(stack){
    var html='';
    /* desktop product header */
    html+='<div class="cmp__phead cmp__reveal" style="--d:120ms">'
        + '<div></div>'
        + '<div class="cmp__ph cmp__ph--droplet"><span class="gradient-text">Droplet</span><span class="cmp__badge">Recommended</span><img class="cmp__pimg" src="'+CMPIMG.droplet+'" alt=""></div>'
        + '<div class="cmp__ph">'+esc(prod('meter').name)+'<img class="cmp__pimg" src="'+CMPIMG.meter+'" alt=""></div>'
        + '<div class="cmp__ph">'+esc(prod('inline').name)+'<img class="cmp__pimg" src="'+CMPIMG.inline+'" alt=""></div>'
        + '</div>';
    /* mobile product header (Droplet vs selected) */
    html+='<div class="cmp__mhead cmp__reveal" style="--d:120ms">'
        + '<div></div>'
        + '<div class="cmp__mh cmp__mh--droplet"><span class="gradient-text">Droplet</span><img class="cmp__pimg" src="'+CMPIMG.droplet+'" alt=""></div>'
        + '<div class="cmp__mh"><span id="cmpAltName">'+esc(prod(altDefault).name)+'</span><img class="cmp__pimg" id="cmpAltImg" src="'+(CMPIMG[altDefault]||'')+'" alt=""></div>'
        + '</div>';
    /* panels */
    /* single continuous matrix — group titles removed, all rows in one panel
       (client feedback: titles added length; keep the matrix tighter) */
    var rows='';
    for(var g=0; g<CFG.groups.length; g++){
      var grp=CFG.groups[g];
      for(var f=0; f<grp.features.length; f++){
        var ft=grp.features[f];
        rows+='<div class="cmp__row"><div class="cmp__crit">'+esc(ft.label)+'</div>'
            + cellHTML('droplet',ft.values.droplet)
            + cellHTML('meter',  ft.values.meter)
            + cellHTML('inline', ft.values.inline)
            + '</div>';
      }
    }
    html+='<div class="cmp__panel cmp__reveal" style="--d:150ms">'+rows+'</div>';
    stack.innerHTML=html;
  }

  /* ---- visually-hidden semantic table (screen-reader source of truth) ---- */
  var srHost=document.getElementById('cmpSr');
  if(srHost){
    function full(v){ return esc(v.big)+(v.sub?(', '+esc(v.sub)):''); }
    var t='<table><caption>Droplet compared with a meter-mounted sensor and an in-line shut-off valve</caption>'
        + '<thead><tr><th scope="col">Feature</th><th scope="col">Droplet</th><th scope="col">Straps on to Meter</th><th scope="col">In-Line Shutoff</th></tr></thead><tbody>';
    for(var gi=0; gi<CFG.groups.length; gi++){
      var gg=CFG.groups[gi];
      for(var fi=0; fi<gg.features.length; fi++){
        var ff=gg.features[fi];
        t+='<tr><th scope="row">'+esc(ff.label)+'</th>'
         + '<td>'+full(ff.values.droplet)+'</td>'
         + '<td>'+full(ff.values.meter)+'</td>'
         + '<td>'+full(ff.values.inline)+'</td></tr>';
      }
    }
    t+='</tbody></table>';
    srHost.innerHTML=t;
  }

  /* ---- mobile competitor selector ---- */
  var segs=[].slice.call(sec.querySelectorAll('.cmp__seg'));
  var live=sec.querySelector('.cmp__live');
  function setAlt(id){
    if(!prod(id)) return;
    sec.setAttribute('data-alt',id);
    segs.forEach(function(b){ var on=b.getAttribute('data-alt')===id; b.classList.toggle('is-active',on); b.setAttribute('aria-pressed', on?'true':'false'); });
    var nm=prod(id).name, an=document.getElementById('cmpAltName');
    if(an) an.textContent=nm;
    var ai=document.getElementById('cmpAltImg');
    if(ai) ai.src=CMPIMG[id]||ai.src;
    if(live) live.textContent='Comparing Droplet with '+nm+'.';
  }
  segs.forEach(function(b){ b.addEventListener('click',function(){ setAlt(b.getAttribute('data-alt')); }); });
  setAlt(altDefault);

  /* ---- closing CTA (front-end add-to-cart; mirror final CTA behaviour) ---- */
  var cta=document.getElementById('cmpCta'), st=document.getElementById('cmpStatus');
  var buybox=document.getElementById('buybox');
  if(buybox && buybox.getAttribute('data-available')==='false' && cta){
    cta.disabled=true; cta.textContent='Sold out';
  }
  if(cta){
    cta.addEventListener('click',function(){
      if(cta.disabled || cta.getAttribute('data-state')==='loading') return;
      cta.setAttribute('data-state','loading'); cta.textContent='Adding…';
      (window.__dropletCartAdd ? window.__dropletCartAdd() : Promise.reject(new Error('cart bridge unavailable')))
        .then(function(){
          cta.setAttribute('data-state','success'); cta.textContent='Added ✓';
          if(st) st.textContent='Added to cart.';
          __sto(function(){ cta.setAttribute('data-state','default'); cta.textContent='Order Droplet'; if(st) st.textContent=''; },2200);
        })
        .catch(function(){
          cta.setAttribute('data-state','default'); cta.textContent='Order Droplet';
          if(st) st.textContent='Something went wrong, please try again.';
        });
    });
  }

  /* ---- entrance reveal ---- */
  var reduce = window.matchMedia && __mm('(prefers-reduced-motion: reduce)').matches;
  if(reduce){ sec.classList.add('is-in'); return; }
  if('IntersectionObserver' in window){
    var io=__io(function(en){
      en.forEach(function(e){ if(e.isIntersecting){ sec.classList.add('is-in'); io.disconnect(); } });
    },{threshold:0.12});
    io.observe(sec);
  } else { sec.classList.add('is-in'); }
});

/* ---------- module 9 ---------- */
M.push(function(__c){
  var __on=__c.on,__off=__c.off,__io=__c.io,__ro=__c.ro,__mo=__c.mo,__raf=__c.raf,__craf=__c.craf,__sto=__c.sto,__cto=__c.cto,__sti=__c.sti,__cti=__c.cti,__mm=__c.mm;

  const nudge = document.getElementById('scrollNudge');
  const bar   = document.getElementById('crumbBar');
  const rail  = document.getElementById('crumbRail');
  const crumbs= [...document.querySelectorAll('#crumbRail .crumb')];
  const hero  = document.getElementById('hero');
  const ugc   = document.getElementById('ugc');
  const app   = document.getElementById('appdemo');
  const cmp   = document.getElementById('compare');
  const revs  = document.getElementById('reviews');
  if(!nudge || !bar || !hero || !cmp) return;

  /* same thresholds the site's own hero beats use */
  const BEAT_CENTERS = [0.31, 0.60, 0.93];   /* crumbs 1..3 within #hero */

  const reduce = __mm('(prefers-reduced-motion: reduce)').matches;
  let idleTimer = null, ticking = false, lastActive = -2;

  function heroProgress(){
    const r = hero.getBoundingClientRect();
    const range = hero.offsetHeight - window.innerHeight;
    return range > 0 ? Math.min(1, Math.max(0, -r.top / range)) : 0;
  }

  /* A/B Option B: the buy box comes after the scroll section, and the rail
     lists "Buy Droplet" in that position. Crumbs are identified by data-c (the
     stop) rather than by their place in the rail, so both orders share this. */
  const lpRoot = document.querySelector('[data-droplet-lp]');
  const lpB = !!(lpRoot && lpRoot.getAttribute('data-layout') === 'b');
  const buyboxEl = document.getElementById('buybox');
  const cid = c => +c.getAttribute('data-c');

  function activeIndex(vh){
    if(revs && revs.getBoundingClientRect().top <= vh*0.5) return 7;
    if(cmp.getBoundingClientRect().top <= vh*0.5) return 6;
    if(app && app.getBoundingClientRect().top <= vh*0.5) return 5;
    if(ugc && ugc.getBoundingClientRect().top <= vh*0.5) return 4;
    if(lpB && buyboxEl && buyboxEl.getBoundingClientRect().top <= vh*0.5) return 0;   /* Buy Droplet */
    const p = heroProgress();
    if(p >= 0.82) return 3;   /* Where to install */
    if(p >= 0.50) return 2;   /* Technology */
    return 1;                 /* How it installs — aqua from the moment the bar appears;
                                 Buy Droplet (0) sits behind it, grayed out */
  }

  function centerCrumb(i){
    const c = crumbs[i]; if(!c) return;
    rail.scrollTo({
      left: c.offsetLeft - rail.clientWidth/2 + c.offsetWidth/2,
      behavior: reduce ? 'auto' : 'smooth'
    });
  }

  function update(){
    ticking = false;
    const vh = window.innerHeight;
    const heroTop = hero.getBoundingClientRect().top;
    const doc = document.documentElement;
    const remaining = doc.scrollHeight - (window.scrollY + vh);

    /* zone: from the long-scroll area until the page bottom approaches
       (the comparison chapter is the last stop — the bar retires as you land) */
    const barZone   = heroTop < vh*0.45 && remaining > vh*0.6;
    const arrowZone = heroTop < vh*0.45 && remaining > vh*1.5;
    bar.classList.toggle('is-visible', barZone);
    nudge.classList.toggle('is-visible', arrowZone);

    /* arrow theme: dark over the bright hero run, light once the dark
       mid-page chapters begin (everything from UGC on stays dark) */
    if(ugc){
      const arrowY = vh - 86;
      nudge.classList.toggle('on-dark', ugc.getBoundingClientRect().top <= arrowY);
    }

    /* crumb states */
    const a = activeIndex(vh);
    const at = crumbs.findIndex(c => cid(c) === a);   /* the active stop's place in the rail */
    crumbs.forEach((c,i)=>{
      c.classList.toggle('is-now',  i === at);
      c.classList.toggle('is-past', i <  at);
    });
    if(a !== lastActive){ lastActive = a; if(at >= 0) centerCrumb(at); }
  }

  function armIdle(delay){
    __cto(idleTimer);
    idleTimer = __sto(() => {
      if(nudge.classList.contains('is-visible')) nudge.classList.add('is-idle');
    }, delay);
  }

  function onScroll(){
    nudge.classList.remove('is-idle');
    armIdle(250);
    if(!ticking){ ticking = true; __raf(update); }
  }

  /* tap a crumb to jump: hero beats use the site's own beat centers */
  const buybox = document.getElementById('buybox');
  crumbs.forEach(c => c.addEventListener('click', () => {
    const i = cid(c);
    let top;
    if(i === 0){
      /* quick link back to the product summary / price / add-to-cart */
      if(!buybox) return;
      const navH = (document.getElementById('nav') || {}).offsetHeight || 65;
      top = buybox.getBoundingClientRect().top + window.scrollY - navH + 2;
    } else if(i <= 3){
      const range = hero.offsetHeight - window.innerHeight;
      top = hero.getBoundingClientRect().top + window.scrollY + BEAT_CENTERS[i-1]*range;
    } else {
      const el = [null,null,null,null,ugc,app,cmp,revs][i];
      if(!el) return;
      top = el.getBoundingClientRect().top + window.scrollY + 2;
    }
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
  }));

  __on(window, 'scroll', onScroll, { passive:true });
  __on(window, 'resize', onScroll, { passive:true });
  __on(window, 'touchend', () => armIdle(250), { passive:true });
  update();
  armIdle(500);
});

/* ---------- module: Junip rating -> hero + buy box ---------- */
M.push(function (__c) {
  var __on = __c.on, __mo = __c.mo;

  /* Liquid already renders the rating from product.metafields.junip.rating when
     the store exposes it, which is the no-flash path. Until it does, the only
     live source is the widget itself, so read it once it mounts and push the
     same number into the hero, the buy box and the reviews sub-line. Read-only:
     nothing here moves or restyles anything Junip owns. */
  var mount = document.getElementById('reviews');
  if (!mount) return;

  var stars  = [].slice.call(document.querySelectorAll('.droplet-lp [data-lp-stars]'));
  var scores = [].slice.call(document.querySelectorAll('.droplet-lp [data-lp-score]'));
  var links  = [].slice.call(document.querySelectorAll('.droplet-lp [data-lp-reviews-link]'));
  var sub    = document.querySelector('.droplet-lp [data-lp-reviews-sub]');
  if (!stars.length && !scores.length) return;

  function apply() {
    var avgEl = mount.querySelector('.junip-product-review-average');
    var cntEl = mount.querySelector('.junip-product-review-count');
    if (!avgEl) return false;

    var rating = parseFloat((avgEl.textContent || '').replace(/[^\d.]/g, ''));
    if (!(rating > 0)) return false;

    var count = cntEl ? parseInt((cntEl.textContent || '').replace(/[^\d]/g, ''), 10) : 0;
    var pct = Math.max(0, Math.min(100, rating / 5 * 100));
    var txt = rating.toFixed(2).replace(/\.?0+$/, '');

    stars.forEach(function (el) { el.style.setProperty('--pct', pct.toFixed(1) + '%'); });
    scores.forEach(function (el) {
      el.textContent = el.getAttribute('data-lp-score') === 'paren' ? '(' + txt + ')' : txt;
    });
    links.forEach(function (a) {
      a.setAttribute('aria-label',
        'Rated ' + txt + ' out of 5 stars' + (count ? ' from ' + count + ' reviews' : '') + '. Read the reviews.');
    });
    if (sub) {
      var src = sub.getAttribute('data-source');
      sub.textContent = 'Rated ' + txt + ' out of 5'
        + (count ? ' · ' + count + ' reviews' : '')
        + (src ? ' · ' + src : '');
    }
    return true;
  }

  if (apply()) return;                      /* already mounted */

  /* Junip renders asynchronously, so watch the mount until it appears. Bounded:
     the observer disconnects on the first successful read, and gives up after
     20s so it can never sit watching the DOM for the life of the page. */
  var obs = __mo(function () { if (apply()) { obs.disconnect(); clearTimeout(bail); } });
  obs.observe(mount, { childList: true, subtree: true });
  var bail = setTimeout(function () { obs.disconnect(); }, 20000);
});

/* ---------- module: rating -> reviews (slides 5 & 9) ---------- */
M.push(function (__c) {
  var __on = __c.on, __mm = __c.mm;

  /* The hero and the buy box both link to #reviews with a plain <a>, so this
     works without JS and stays keyboard-accessible; the handler only upgrades
     the jump to a smooth scroll that clears the sticky landing nav. */
  var links = [].slice.call(document.querySelectorAll('.droplet-lp [data-lp-reviews-link]'));
  if (!links.length) return;

  var reduce = window.matchMedia && __mm('(prefers-reduced-motion: reduce)').matches;

  links.forEach(function (a) {
    __on(a, 'click', function (e) {
      var target = document.getElementById('reviews');
      if (!target) return;                       /* reviews off: let the anchor be */
      e.preventDefault();
      var nav = document.getElementById('nav');
      var navH = (nav && nav.offsetHeight) || 0;
      var top = target.getBoundingClientRect().top + window.scrollY - navH - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#reviews');
    });
  });
});

/* ---------- module: mobile nav (burger + overlay) ---------- */
M.push(function (__c) {
  var __on = __c.on, __mm = __c.mm, __mo = __c.mo;

  var nav = document.querySelector('.droplet-lp .nav');
  var burger = document.getElementById('navBurger');
  var overlay = document.getElementById('navOverlay');
  if (!nav || !burger || !overlay) return;

  /* if the section re-rendered mid-open, clear the stale lock */
  document.documentElement.classList.remove('droplet-nav-locked');

  var open = false;

  /* the overlay borrows whichever tone the nav is currently wearing */
  function syncTone() {
    var dark = nav.classList.contains('is-dark') || nav.classList.contains('is-transparent');
    overlay.classList.toggle('nav-overlay--dark', dark);
  }

  function setOpen(next) {
    open = next;
    burger.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    overlay.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('droplet-nav-locked', open);
    if (open) syncTone();
  }

  __on(burger, 'click', function () { setOpen(!open); });

  /* tapping any link closes it; tapping the backdrop does too */
  __on(overlay, 'click', function (e) {
    if (e.target.closest('a') || e.target === overlay) setOpen(false);
  });

  __on(document, 'keydown', function (e) {
    if (open && (e.key === 'Escape' || e.key === 'Esc')) setOpen(false);
  });

  /* crossing to desktop must not leave a locked body behind */
  var mqDesktop = __mm('(min-width:769px)');
  var onBreakpoint = function () { if (mqDesktop.matches && open) setOpen(false); };
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onBreakpoint);
  else mqDesktop.addListener(onBreakpoint);

  /* the scroll logic swaps .is-dark / .is-transparent on the nav as you move
     down the page; mirror that onto the overlay so it opens in the right tone */
  var toneWatcher = __mo(syncTone);
  toneWatcher.observe(nav, { attributes: true, attributeFilter: ['class'] });
  syncTone();
});

/* ---------- module: Shopify cart bridge ---------- */
/* The buy CTAs were front-end simulations in the standalone build. They now run
   through Dawn's own <product-form>, which POSTs to routes.cart_add_url, renders
   the cart drawer and publishes cartUpdate / cartError. Reusing it means we
   inherit Dawn's error handling and drawer refresh rather than reimplementing
   them. The form itself is visually hidden and carries the linked variant. */
M.push(function (__c) {
  var __on = __c.on, __sto = __c.sto, __cto = __c.cto;

  var hasPubSub = (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object');

  function badgeUpdate(count) {
    var nodes = document.querySelectorAll('.droplet-lp [data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
      if (count > 0) nodes[i].removeAttribute('hidden');
      else nodes[i].setAttribute('hidden', '');
    }
  }

  function refreshBadge() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') badgeUpdate(c.item_count); })
      .catch(function () { /* badge is cosmetic; never block the purchase on it */ });
  }

  /* Returns a promise the existing CTA handlers already know how to consume. */
  window.__dropletCartAdd = function () {
    return new Promise(function (resolve, reject) {
      var form = document.getElementById('lpProductForm');
      if (!form || !form.isConnected) {
        reject(new Error('[droplet-lp] no Shopify product is linked to this section'));
        return;
      }

      var settled = false, offOk, offErr, timer;

      function finish(ok, payload) {
        if (settled) return;
        settled = true;
        if (offOk) offOk();
        if (offErr) offErr();
        if (timer) __cto(timer);
        if (ok) { refreshBadge(); resolve(payload); } else { reject(payload); }
      }

      if (hasPubSub) {
        offOk = subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) { finish(true, d); });
        offErr = subscribe(PUB_SUB_EVENTS.cartError, function (d) { finish(false, d); });
      }

      /* Never leave a button stuck on "Adding…". Fail rather than resolve: a
         false "Added ✓" would send someone away thinking they'd bought it. */
      timer = __sto(function () {
        finish(false, new Error('[droplet-lp] no cart response within 12s'));
      }, 12000);

      if (form.requestSubmit) form.requestSubmit();
      else {
        var btn = document.getElementById('lpAddToCart');
        if (btn) btn.click(); else finish(false, new Error('submit unavailable'));
      }
    });
  };

  /* the top hero's Buy button had no handler at all in the standalone build */
  var heroCta = document.querySelector('.droplet-lp .vhero__cta');
  if (heroCta) {
    __on(heroCta, 'click', function () {
      if (heroCta.getAttribute('data-state') === 'loading') return;
      heroCta.setAttribute('data-state', 'loading');
      window.__dropletCartAdd()
        .then(function () { heroCta.removeAttribute('data-state'); })
        .catch(function () { heroCta.removeAttribute('data-state'); });
    });
  }
});

  /* ----------------------------------------------------------- lifecycle */
  var ctx = null;

  function destroy() {
    if (!ctx) return;
    ctx.destroy();
    ctx = null;
  }

  function init() {
    destroy();
    var root = document.querySelector('[data-droplet-lp]');
    if (!root) return;
    ctx = makeCtx();
    for (var i = 0; i < M.length; i++) {
      try {
        M[i](ctx);
      } catch (e) {
        /* One failing block must never take the rest of the page down. */
        if (window.console && console.error) {
          console.error('[droplet-lp] block ' + i + ' failed to start:', e);
        }
      }
    }
  }

  function isOurs(target) {
    if (!target || !target.querySelector) return false;
    return !!target.querySelector('[data-droplet-lp]');
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (isOurs(e.target)) init();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (isOurs(e.target)) destroy();
  });

  window.__dropletLP = { init: init, destroy: destroy, modules: M };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
